import { AacDecoder } from '../aac/aacDecoder';
import { DecodedPcmFloat32Channels } from '../aac/types';
import type { EncodedData } from './demuxerTypes';
import { samplingFrequencyInHz } from '../aac/data';

export class PcmSampleFetcher {

  private decoders: AacDecoder[] = [];

  getDecodedPcmFloat32Channels(encodedData: EncodedData): DecodedPcmFloat32Channels {
    if (encodedData.encodedAudioData.length === 0) {
      // No audio
      return {
        sampleRateInHz: 0,
        channels: [],
      };
    }
    const results: DecodedPcmFloat32Channels = {
      sampleRateInHz: encodedData.encodedAudioData[0].sampleRateInHz,
      channels: [],
    };
    for (let i = 0; i < encodedData.encodedAudioData.length; i++) {
      if (this.decoders[i] === undefined) {
        const frequencyIndex = samplingFrequencyInHz.indexOf(encodedData.encodedAudioData[i].sampleRateInHz);
        if (frequencyIndex === -1) {
          throw new Error(`Invalid frequency: ${encodedData.encodedAudioData[i].sampleRateInHz}`);
        }

        this.decoders[i] = new AacDecoder(frequencyIndex, encodedData.encodedAudioData[i].channelConfiguration, false);
      }
      const pcmSamples = this.decoders[i].decodeAacFrames(encodedData.encodedAudioData[i]);
      for (let n = 0; n < pcmSamples.channels.length; n++) {
        results.channels.push(pcmSamples.channels[n]);
      }
    }

    return results;
  }

}
